import { getIn } from 'formik';

export function hasMinSubmitCount(submitCount) {
  return submitCount > 0;
}

export function getErrors(errors, name) {
  return getIn(errors, name);
}

export function getTouched(touched, name) {
  return getIn(touched, name);
}

export function getValues(values, name) {
  return getIn(values, name);
}

export function shouldShowError({ submitCount, touched, errors }, name) {
  return hasMinSubmitCount(submitCount) && !!(getTouched(touched, name) && getErrors(errors, name));
}
